import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, Card, Heading, Spinner, Text, Table, Thead, Tbody, Tr, Th, Td, Button, Badge } from '@chakra-ui/react';
import { ArrowBackIcon } from '@chakra-ui/icons';
import Axios from '../utils/httpClient';
import Layout from './Layout';

const PRIMARY = '#133654';

const categoryTitles = {
  'i': "I. O'QUV-METODIK ISHLAR VA O'QITISH SIFATI – 35",
  'ii': "II. ILMIY-INNOVATSION FAOLIYAT - 35",
  'iii': "III. XALQARO HAMKORLIK FAOLIYATI - 25",
  'iv': "IV. IJTIMOIY-MA'NAVIY FAOLIYATI, IJRO VA MEHNAT INTIZOMI - 20"
};

const TeachersByCategoryRanking = () => {
  const { category } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [teachers, setTeachers] = useState([]);

  useEffect(() => {
    loadTeachers();
  }, [category]);

  const loadTeachers = () => {
    setLoading(true);
    Axios().get(`api/v1/application/teachers-by-category/`, {
      params: { category }
    })
      .then(res => {
        setTeachers(res?.data?.teachers || []);
      })
      .catch(err => {
        console.error('Error loading teachers:', err);
      })
      .finally(() => setLoading(false));
  };

  const categoryTitle = categoryTitles[category] || 'Kategoriya';

  return (
    <Layout showLoginButton={true}>
      <Box p={4}>
        <Box display='flex' gap={3} alignItems='center' mb={4}>
          <Button
            size='sm'
            leftIcon={<ArrowBackIcon />}
            bg={PRIMARY}
            color='white'
            borderRadius='10px'
            _hover={{ bg: '#0f2a42' }}
            onClick={() => navigate('/')}
          >
            Orqaga
          </Button>
          <Heading size='md'>{categoryTitle}</Heading>
        </Box>

        <Card p={4}>
          <Heading size='sm' mb={4}>
            Eng yuqori ball to'plagan o'qituvchilar ({teachers.length} ta)
          </Heading>

          {loading ? (
            <Box display="flex" justifyContent="center" p={8}>
              <Spinner size="xl" color={PRIMARY} />
            </Box>
          ) : teachers.length === 0 ? (
            <Text color="gray.600">Bu kategoriya bo'yicha hali baholangan o'qituvchilar yo'q</Text>
          ) : (
            <Table variant="simple" size="sm">
              <Thead>
                <Tr bg="gray.50">
                  <Th width="60px">No</Th>
                  <Th>O'qituvchi</Th>
                  <Th width="120px" textAlign="right">Jami ball</Th>
                </Tr>
              </Thead>
              <Tbody>
                {teachers.map((teacher, idx) => (
                  <Tr 
                    key={teacher.teacher_id} 
                    _hover={{ bg: 'gray.100', cursor: 'pointer' }}
                    onClick={() => navigate('/login')}
                  >
                    <Td>
                      <Badge
                        colorScheme={teacher.rank === 1 ? 'yellow' : teacher.rank === 2 ? 'gray' : teacher.rank === 3 ? 'orange' : 'blue'}
                        fontSize="md"
                        px={3}
                        py={1}
                        borderRadius="full"
                      >
                        {teacher.rank}
                      </Badge>
                    </Td>
                    <Td>
                      <Text fontWeight={600}>{teacher.teacher_name}</Text>
                      <Text fontSize="xs" color="gray.600">{teacher.username}</Text>
                    </Td>
                    <Td textAlign="right">
                      <Text fontWeight={700} fontSize="lg" color={PRIMARY}>
                        {teacher.total_points.toFixed(2)}
                      </Text>
                    </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          )}
        </Card>
      </Box>
    </Layout>
  );
};

export default TeachersByCategoryRanking;
